import * as React from "react";

const MaterialErrorSVG = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 -960 960 960"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Libro: borde rojo */}
      <path
        d="
          M140-720
          Q140-770 190-770
          H390
          Q450-770 480-720
          Q510-770 570-770
          H770
          Q820-770 820-720
          V-280
          Q820-230 770-230
          H570
          Q510-230 480-190
          Q450-230 390-230
          H190
          Q140-230 140-280
          Z
        "
        stroke="#E52D3D"
        strokeWidth={72}
      />

      {/* Libro: interior blanco */}
      <path
        d="
          M140-720
          Q140-770 190-770
          H390
          Q450-770 480-720
          Q510-770 570-770
          H770
          Q820-770 820-720
          V-280
          Q820-230 770-230
          H570
          Q510-230 480-190
          Q450-230 390-230
          H190
          Q140-230 140-280
          Z
        "
        stroke="#FFF"
        strokeWidth={36}
      />

      {/* División central */}
      <path
        d="M480-710V-235"
        stroke="#E52D3D"
        strokeWidth={54}
      />

      <path
        d="M480-710V-235"
        stroke="#FFF"
        strokeWidth={24}
      />

      {/* Líneas del contenido */}
      <g stroke="#E52D3D" strokeWidth={42}>
        <path d="M235-590H380" />
        <path d="M235-480H350" />
        <path d="M580-590H725" />
      </g>

      <g stroke="#FFF" strokeWidth={18}>
        <path d="M235-590H380" />
        <path d="M235-480H350" />
        <path d="M580-590H725" />
      </g>

      {/* Círculo de error */}
      <circle
        cx="730"
        cy="-280"
        r="145"
        fill="#E52D3D"
        stroke="#FFF"
        strokeWidth={26}
      />

      {/* Signo de exclamación */}
      <path
        d="M730-355V-270"
        stroke="#FFF"
        strokeWidth={46}
      />

      <circle cx="730" cy="-215" r="24" fill="#FFF" />
    </svg>
  );
};

export default MaterialErrorSVG;